// extracted by mini-css-extract-plugin
module.exports = {"summary__stats":"G_cv","summary__stats__links":"G_cw","summary__stats__links__single":"G_cx"};